import { styled, css } from "styled-components";
import { transition } from "../../styles/mixins";
import { unitsToPercentage } from "../../utils/helpers";

export const TableBar = styled.div`
  background-color: var(--border-color);
  display: inline-block;
  height: var(--space-2);
  position: relative;
  width: 100%;

  &::after {
    ${transition('width')}
    background-color: var(--color-theme-secondary-400);
    content: '';
    height: 100%;
    left: 0;
    position: absolute;
    top: 0;
    transition-delay: 250ms;
    width: ${props => props.$current && props.$max && unitsToPercentage(props.$current, props.$max)}%;
  }
`;

export const TableActions = styled.div`
  align-items: center;
  display: flex;
  gap: var(--space-2);
`;

export const TableSortColumn = styled.div`
  align-items: center;
  display: flex;
  gap: var(--space-2);
`;

export const Table = styled.table`
  border-collapse: collapse;
  table-layout: fixed;
  width: 100%;

   th {
    font-weight: 600;
    text-align: left;
  }

  th,
  td {
    padding-block: var(--space-2);
  }

  th.middle,
  td.middle {
    vertical-align: middle;
  }

  th.error,
  td.error {
    color: red;
  }

  th.success,
  td.success {
    color: green;
  }

  thead tr,
  tr:not(:last-child) {
    border-bottom: var(--border-width) var(--border-style) var(--border-color);
  }

  tr.action:hover,
  td.action:hover {
    background-color: rgba(var(--color-theme-primary-300-rgb), 0.33);
  }

  .gap {
    align-items: center;
    display: flex;
    gap: var(--space-1);
  }

  ${props => props.$style == 'striped' && css`
    tbody tr:nth-child(odd) {
      background-color: rgba(var(--color-theme-primary-300-rgb), 0.33);
    }

    th,
    td {
      padding-inline: var(--space-3);
    }

    tbody tr.highlight {
      background-color: var(--color-theme-secondary-500);
    }
  `}
`;

export default Table;
